import useAppStore from "@/context/store";
import { getMe, logout, switchOrg } from "@/services";
import getPageData from "@/tracker/shared/getPageData";
import oauth2Client from "@/utils/auth";
import { getOrgIdByUser } from "@/utils/gaoding";
import { useMemo } from "react";
import HBMessage from "../HBMessage";
import { onThirdLoginOk } from "./shared/third";

const LoginDialog = {
  open: async (
    props: {
      /**来源页面 */
      source?: string;
      /**来源位置 */
      source_location?: string;
    } & Record<string, any> = {}
  ) => {
    // const loginAb = await getExpsValue("login", "string_0");

    // if (loginAb !== "string_1") {
    //   return import("./loginView").then(({ default: RawLoginDialog }) => {
    //     return RawLoginDialog.open(props);
    //   });
    // } else {

    // 页面不在活跃状态，不进行登录, 避免多个tab触发弹窗
    if (document.visibilityState !== "visible") {
      return;
    }

    // 一体化登录
    const oauthLogin = oauth2Client?.openLogin({
      projectName: "huaban",
      target: props?.target || "popup",
      source: props?.source || getPageData().page_nm,
      sourceLocation: props?.source_location,
    });

    if (typeof oauthLogin === "string") {
      console.error(oauthLogin);
      return;
    }

    window.addEventListener("message", onThirdLoginOk);

    oauthLogin?.onSuccess(async () => {
      let user = await getMe();

      const orgId = getOrgIdByUser(user);
      if (orgId) {
        // 一体化登录之后需要绑定租户，不然商业化接口会报未绑定租户的问题
        await switchOrg(orgId);
        user.extra.org_id = orgId;
      }

      if (user.err) {
        HBMessage.error("登录异常");
        return;
      }

      useAppStore.getState().setUser(user);
      props?.onOk?.(user);
    });

    oauthLogin?.onFailed(() => {
      HBMessage.error("登录失败");
      // todo: 登录失败
      props?.onCancel?.();
    });

    oauthLogin?.onCancel(() => {
      props?.onCancel?.();
    });
    // }
  },

  asyncOpen: async (props: any = {}) => {
    return new Promise((resolve) => {
      LoginDialog.open({
        ...props,
        source_location: props.source_location,
        async onOk(data: IUser) {
          resolve(data);
        },
        onCancel() {
          resolve(false);
        },
      });
    });
  },
};

export default LoginDialog;

export function useLogin() {
  return useMemo(() => {
    return {
      async login(
        props: {
          target?: "blank" | "popup" | "redirect" | "null";
          source_location?: string;
          [key: string]: any;
        } = {}
      ) {
        return new Promise<IUser | false>((resolve) => {
          // 关闭其他弹框，避免同时出现多个弹框
          LoginDialog.open({
            ...props,
            source_location: props.source_location,
            async onOk(data: IUser) {
              resolve(data);
            },
            onCancel() {
              resolve(false);
            },
          });
        });
      },

      async logout() {
        await logout();
        useAppStore.getState().setUser(null);
      },
    };
  }, []);
}
